var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntCommercialMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25581 11.0206C5.09292 11.3101 5 11.6442 5 12V20C5 21.1046 5.89543 22 7 22H20C21.1046 22 22 21.1046 22 20V12C22 11.6442 21.9071 11.3101 21.7442 11.0206L14.8943 15.05C14.0337 15.5562 12.9663 15.5562 12.1057 15.05L5.25581 11.0206Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4387 10.0483C20.2975 10.0167 20.1507 10 20 10H7C6.84929 10 6.70247 10.0167 6.56129 10.0483L12.8662 13.7571C13.2574 13.9872 13.7426 13.9872 14.1338 13.7571L20.4387 10.0483Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67332 8.46381H3C3.23346 5.2569 5.54403 2.63879 8.56641 2C8.55234 2.01457 8.5384 2.0293 8.52458 2.04418C8.1277 2.47161 7.79453 3.06134 7.5258 3.7456C7.03507 4.9951 6.72466 6.64835 6.67332 8.46381Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01395 9.70181C3.08204 10.4136 3.2526 11.0947 3.51043 11.7298C3.55036 11.2097 3.70456 10.7188 3.94865 10.285L3.96275 10.2599L3.01395 9.70181Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4336 2C14.456 2.63879 16.7665 5.2569 17 8.46381H13.3267C13.2753 6.64835 12.9649 4.9951 12.4742 3.7456C12.2055 3.06134 11.8723 2.47161 11.4754 2.04418C11.4616 2.0293 11.4477 2.01457 11.4336 2Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50341 4.14386C8.07068 5.24567 7.77786 6.75852 7.72668 8.4638H12.2733C12.2221 6.75852 11.9293 5.24567 11.4966 4.14386C11.2572 3.53437 10.9854 3.07712 10.7104 2.78101C10.4365 2.48603 10.1963 2.38696 9.99999 2.38696C9.80372 2.38696 9.56348 2.48603 9.28958 2.78101C9.01463 3.07712 8.74278 3.53437 8.50341 4.14386Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntCommercialMail);
export default __webpack_public_path__ + "static/media/int-commercial-mail.ebdd10c575277d9d6843a4014d1c9638.svg";
export { ForwardRef as ReactComponent };